(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3128],{

/***/ 27003:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn",
      function () {
        return __webpack_require__(10714);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ty": function() { return /* binding */ DashboardIntervalValues; },
/* harmony export */   "f_": function() { return /* binding */ useDashboardStats; },
/* harmony export */   "wc": function() { return /* binding */ QueryKeyDashboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50815);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95915);
/* harmony import */ var _useSession__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87627);








var DashboardIntervalValues = [
    "Week",
    "Month",
    "Year",
    "All"
];
var QueryKeyDashboard = "dashboard-stats";
var useDashboardStats = function(interval) {
    var network = (0,_useSession__WEBPACK_IMPORTED_MODULE_1__/* .useSession */ .k)().network;
    var res = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        QueryKeyDashboard,
        network.networkId,
        interval
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var selectedInterval, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedInterval = interval.toLowerCase();
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/data-dashboard?interval=" + selectedInterval)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    }), (0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .queryOptions */ .C)(false, true));
    var _data;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, res), {
        data: (_data = res.data) !== null && _data !== void 0 ? _data : []
    });
};


/***/ }),

/***/ 10714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ learn; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./src/v2/components/layout/website/LandingFooter.tsx
var LandingFooter = __webpack_require__(28424);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/v2/components/ui/buttons/buttonWithIcon/index.tsx + 3 modules
var buttonWithIcon = __webpack_require__(52787);
// EXTERNAL MODULE: ./src/v2/components/ui/icons/vesta/index.tsx
var vesta = __webpack_require__(77435);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/theme/styles/mixins.tsx
var mixins = __webpack_require__(52230);
// EXTERNAL MODULE: ./src/v2/components/layout/website/SlideWrapper.tsx
var SlideWrapper = __webpack_require__(47697);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/learn/IntegratedPartnersSlide.tsx








function IntegratedPartnersSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                variant: "h4",
                children: "Experience the power of VST through our integrated partners"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "row",
                spacing: 4,
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: mixins/* secondaryBox */.J0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(vesta/* VestaIcon */.QA, {
                                            size: 64,
                                            icon: vesta/* VestaPartnerIcons.RADIANT */.LK.RADIANT,
                                            noBg: true,
                                            noBorder: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h5",
                                            color: colors/* primaryColors.100 */.w2[100],
                                            children: "Radiant Capital"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    mt: 2,
                                    color: colors/* primaryColors.100 */.w2[100],
                                    children: "Deposit your VST on Radiant"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                    variant: "secondary",
                                    iconSize: 16,
                                    iconType: "arrow",
                                    sx: {
                                        mt: 4
                                    },
                                    children: "VISIT RADIANT"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: mixins/* secondaryBox */.J0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(vesta/* VestaIcon */.QA, {
                                            size: 64,
                                            icon: vesta/* VestaPartnerIcons.RADIANT */.LK.RADIANT,
                                            noBg: true,
                                            noBorder: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h5",
                                            color: colors/* primaryColors.100 */.w2[100],
                                            children: "Arable Finance"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    mt: 2,
                                    color: colors/* primaryColors.100 */.w2[100],
                                    children: "Deposit you VST on Arable"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                    variant: "secondary",
                                    iconSize: 16,
                                    iconType: "arrow",
                                    sx: {
                                        mt: 4
                                    },
                                    children: "VISIT ARABLE"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var learn_IntegratedPartnersSlide = (IntegratedPartnersSlide);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(9253);
// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/LineChart.js
var LineChart = __webpack_require__(49104);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/CartesianGrid.js
var CartesianGrid = __webpack_require__(14195);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(75358);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(56880);
// EXTERNAL MODULE: ./src/components/theme/typography.ts
var typography = __webpack_require__(62157);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/learn/PegSlide.tsx










function linspace(start, stop, iterations) {
    var endpoint = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var div = endpoint ? iterations - 1 : iterations;
    var step = (stop - start) / div;
    return Array.from({
        length: iterations
    }, function(_, i) {
        return start + step * i;
    });
}
function generateVrrCurveDataPoints(iterations) {
    var xRange = linspace(-10, 10, iterations);
    var vrrConstant = -1.0397;
    var vrrHighBaseRate = 1.25;
    var vrrMedBaseRate = 0.75;
    var vrrLowBaseRate = 0.5;
    var vrrHighMax = 226.250672;
    var vrrMedMax = 135.750403;
    var vrrLowMax = 90.500269;
    return xRange.map(function(xDepegVal) {
        return {
            depeg: xDepegVal,
            vrrHigh: Math.min(vrrHighMax, vrrHighBaseRate * Math.exp(vrrConstant * xDepegVal)),
            vrrMed: Math.min(vrrMedMax, vrrMedBaseRate * Math.exp(vrrConstant * xDepegVal)),
            vrrLow: Math.min(vrrLowMax, vrrLowBaseRate * Math.exp(vrrConstant * xDepegVal))
        };
    });
}
var data = generateVrrCurveDataPoints(500);
var VRRPegGraph = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
        width: "99%",
        height: 300,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
            data: data,
            margin: {
                top: 5,
                right: 10,
                left: 20,
                bottom: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                    stroke: colors/* primaryColors.900 */.w2[900],
                    strokeDasharray: "3 3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* label3 */.dM), {
                        fill: colors/* primaryColors.400 */.w2[400]
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "PRICE PEG"
                    }),
                    ticks: [
                        -10,
                        -8,
                        -6,
                        -4,
                        -2,
                        0,
                        2,
                        4,
                        6,
                        8,
                        10
                    ],
                    tickFormatter: function(val) {
                        return "".concat(val, "%");
                    },
                    dataKey: "depeg",
                    axisLine: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* label3 */.dM), {
                        fill: colors/* primaryColors.400 */.w2[400]
                    }),
                    axisLine: false,
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "VRR"
                    }),
                    tickSize: 0,
                    tickFormatter: function(val) {
                        return "".concat(val, "%");
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                    type: "monotone",
                    dataKey: "vrrHigh",
                    stroke: colors/* secondaryColors.500 */.St[500],
                    dot: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                    type: "monotone",
                    dataKey: "vrrMed",
                    stroke: colors/* secondaryColors.300 */.St[300],
                    dot: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                    type: "monotone",
                    dataKey: "vrrLow",
                    stroke: colors/* secondaryColors.100 */.St[100],
                    dot: false
                })
            ]
        })
    });
};
function PegSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            direction: {
                xs: "column-reverse",
                sm: "row"
            },
            textAlign: {
                xs: "center",
                sm: "start"
            },
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 5.5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                children: "Pegged to $1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        color: colors/* primaryColors.100 */.w2[100],
                                        children: "Price Floor enabled by Vesta Reference Rate"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: colors/* primaryColors.400 */.w2[400],
                                        children: "Rate goes up as token depegs, encouraging supply reduction"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        color: colors/* primaryColors.100 */.w2[100],
                                        children: "Price Ceiling enabled by low liquidation ratio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: colors/* primaryColors.400 */.w2[400],
                                        children: "If the stablecoin goes above $1.1, people could mint VST using ETH and sell VST into the open market to realize an arbitrage"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                iconType: "asterisk",
                                children: " Learn More "
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 5.5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VRRPegGraph, {})
                })
            ]
        })
    });
}
/* harmony default export */ var learn_PegSlide = (PegSlide);

// EXTERNAL MODULE: ./src/v2/components/ui/label/index.tsx
var label = __webpack_require__(45306);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useAllVaultData.ts
var useAllVaultData = __webpack_require__(90160);
// EXTERNAL MODULE: ./src/components/types.ts
var types = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/components/utils/utils.tsx
var utils = __webpack_require__(63189);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/learn/SecureLiquidiationsSlide.tsx










function SecureLiquidationsSlide() {
    var ref = (0,useAllVaultData/* useAllVaultData */.V)(), totalSystemDebtVst = ref.computed.totalSystemDebtVst;
    //@todo VFF SAVING MODULE V2
    var safetyVaultTotalVst = 4206900;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                variant: "h4",
                mb: 4,
                children: "Liquidations are fully secured"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: {
                    xs: "column",
                    sm: "row"
                },
                spacing: 4,
                mb: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 4,
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                variant: "vertical",
                                labelTitle: "FIRST LINE OF DEFENSE",
                                labelValueVariant: "h6",
                                labelValue: "Asset-specific Stability Pools"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                color: colors/* primaryColors.400 */.w2[400],
                                children: "VST in stability pools ensures immediate liquidation of underwater positions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                variant: "vertical",
                                labelTitle: "AMOUNT IN STABILITY POOL",
                                labelValueVariant: "h6",
                                labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                    value: totalSystemDebtVst - safetyVaultTotalVst,
                                    displayType: types/* EDisplayType.USD */.co.USD
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                iconType: "asterisk",
                                children: " Learn More "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            borderLeft: {
                                xs: undefined,
                                sm: "1px solid ".concat(colors/* secondaryColors.200 */.St[200])
                            },
                            borderBottom: {
                                xs: "1px solid ".concat(colors/* secondaryColors.200 */.St[200]),
                                sm: undefined
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 4,
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                variant: "vertical",
                                labelTitle: "SECOND LINE OF DEFENSE",
                                labelValueVariant: "h6",
                                labelValue: "Saving Module"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                color: colors/* primaryColors.400 */.w2[400],
                                children: "Locked capital in saving module fully guarantees liquidation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                variant: "vertical",
                                labelTitle: "AMOUNT IN SAVING MODULE",
                                labelValueVariant: "h6",
                                labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                    value: safetyVaultTotalVst,
                                    displayType: types/* EDisplayType.USD */.co.USD
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                iconType: "asterisk",
                                children: " Learn More "
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var SecureLiquidiationsSlide = (SecureLiquidationsSlide);

// EXTERNAL MODULE: ./src/v2/components/ui/images/index.tsx + 1 modules
var ui_images = __webpack_require__(24639);
// EXTERNAL MODULE: ./src/config/types.ts
var config_types = __webpack_require__(87859);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/learn/StablecoinLandingSlide.tsx
/* eslint-disable react/no-unknown-property */ 






function StablecoinLandingSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden",
            pt: 32,
            pb: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            direction: {
                xs: "column-reverse",
                sm: "row"
            },
            justifyContent: "start",
            textAlign: {
                xs: "center",
                sm: "left"
            },
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    mt: {
                        xs: 12,
                        sm: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            mt: 4,
                            children: "Stablecoin Explainer & Features"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            mt: 4,
                            mb: 8,
                            color: colors/* primaryColors.400 */.w2[400],
                            children: "Experience Unparalleled Security & Censorship-Resistance with our overcollateralized stablecoin: VST."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* NativeTokenOrbital */.nY, {
                            asset: config_types/* ENativeAsset.VST */.tx.VST
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var learn_StablecoinLandingSlide = (StablecoinLandingSlide);

// EXTERNAL MODULE: ./src/v2/components/ui/icons/assets/index.tsx
var assets = __webpack_require__(66023);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/learn/StakingSlide.tsx
/* eslint-disable react/no-unknown-property */ 








function StakingSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        children: "Participate in our staking programmes and start earning substantial returns from day one"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        color: colors/* primaryColors.400 */.w2[400],
                        my: 4,
                        children: "An in-house innovation to put your VST at work and further protect the protocol by acting as a secondary security buffer to backstop liquidation, similarly to stability pools."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: {
                    xs: "column",
                    sm: "row"
                },
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: mixins/* secondaryBox */.J0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* AssetIcon */.Y, {
                                            size: 42,
                                            asset: config_types/* ENativeAsset.VSTA */.tx.VSTA,
                                            noBg: true,
                                            noBorder: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h5",
                                            children: "Saving Module"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    my: 4,
                                    color: colors/* primaryColors.400 */.w2[400],
                                    children: "Deposit VST into Vesta Saving Module to earn 10% yield on stablecoin"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                    iconType: "asterisk",
                                    children: "VESTA SAVING MODULE"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: mixins/* secondaryBox */.J0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* AssetIcon */.Y, {
                                            size: 42,
                                            asset: config_types/* EOtherAsset.FRAX */.v4.FRAX,
                                            noBg: true,
                                            noBorder: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h5",
                                            children: "Frax Gauge"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    my: 4,
                                    color: colors/* primaryColors.400 */.w2[400],
                                    children: "Provide liquidity into the VST-FRAX pool to earn 20% APR in FXS."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                    iconType: "asterisk",
                                    children: "LIQUIDITY STAKING"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var learn_StakingSlide = (StakingSlide);

// EXTERNAL MODULE: ./src/v2/components/layout/statistics/graphs/collateralizationGraph.tsx
var collateralizationGraph = __webpack_require__(12614);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/learn/VstCollateralizationSlide.tsx










function VstCollateralizationSlide() {
    var ref = (0,useAllVaultData/* useAllVaultData */.V)(), _computed = ref.computed, totalCollateralUsd = _computed.totalCollateralUsd, totalSystemDebtVst = _computed.totalSystemDebtVst;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 4,
                mb: 4,
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        children: "VST is an over-collateralized stablecoin"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        color: colors/* primaryColors.400 */.w2[400],
                        children: "At Vesta we believe in decentralization, so VST has 0 direct centralized stablecoins as collateral and we are not planning to add any."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: {
                    xs: "column-reverse",
                    sm: "column"
                },
                spacing: 4,
                pb: {
                    xs: 58,
                    sm: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(collateralizationGraph/* CollateralizationGraph */.m, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: {
                            xs: "column",
                            sm: "row"
                        },
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                sx: mixins/* secondaryBox */.J0,
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        color: colors/* primaryColors.700 */.w2[700],
                                        children: "Total Value Locked"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        color: colors/* primaryColors.100 */.w2[100],
                                        children: (0,utils/* displayFormatUnits */.Hz)({
                                            value: totalCollateralUsd,
                                            displayType: types/* EDisplayType.USD */.co.USD
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                sx: mixins/* secondaryBox */.J0,
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        color: colors/* primaryColors.700 */.w2[700],
                                        children: "Collateralization Ratio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "h6",
                                        color: colors/* primaryColors.100 */.w2[100],
                                        children: [
                                            "1 VST backed by",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                component: "span",
                                                variant: "h6",
                                                color: colors/* secondaryColors.200 */.St[200],
                                                children: [
                                                    " ",
                                                    (0,utils/* displayFormatUnits */.Hz)({
                                                        value: totalCollateralUsd / totalSystemDebtVst,
                                                        displayType: types/* EDisplayType.USD */.co.USD
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var learn_VstCollateralizationSlide = (VstCollateralizationSlide);

// EXTERNAL MODULE: ./src/v2/components/ui/containers/fade/index.tsx
var fade = __webpack_require__(41394);
;// CONCATENATED MODULE: ./src/pages/learn.tsx











var LearnPage = function() {
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setVisible(true);
        }, 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fade/* FadeContainer */.B, {
                visible: visible ? 1 : 0,
                time: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(learn_StablecoinLandingSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(learn_VstCollateralizationSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(learn_PegSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(learn_StakingSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureLiquidiationsSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(learn_IntegratedPartnersSlide, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var learn = (LearnPage);


/***/ }),

/***/ 12614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CollateralizationGraph; }
/* harmony export */ });
/* unused harmony export COLLATERALIZATION_PIE_CHART_HEIGHT */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86886);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45108);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9253);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(73604);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46208);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43815);
/* harmony import */ var src_v2_components_ui_icons_assets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66023);
/* harmony import */ var src_v2_components_ui_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45306);
/* harmony import */ var src_v2_components_ui_loadSkeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66820);
/* harmony import */ var _components_hooks_dashboard_useDashboardStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18778);
/* harmony import */ var _components_hooks_utils_useIsMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56490);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16381);
/* harmony import */ var _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52230);
/* harmony import */ var _components_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87493);
/* harmony import */ var _components_utils_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63189);
/* harmony import */ var _config_protocol__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87055);
/* harmony import */ var _config_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87859);
/* harmony import */ var _svgGradient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41606);


















var MOBILE_INNER_RADIUS = 80;
var renderActiveShape = function(props) {
    var RADIAN = Math.PI / 180;
    var cx = props.cx, cy = props.cy, midAngle = props.midAngle, innerRadius = props.innerRadius, outerRadius = props.outerRadius, startAngle = props.startAngle, endAngle = props.endAngle, payload = props.payload, percent = props.percent;
    var isMobile = innerRadius === MOBILE_INNER_RADIUS;
    var sin = Math.sin(-RADIAN * midAngle);
    var cos = Math.cos(-RADIAN * midAngle);
    var sx = cx + (outerRadius + 10) * cos;
    var sy = cy + (outerRadius + 10) * sin;
    var mx = cx + (outerRadius + 50) * cos;
    var my = cy + (outerRadius + 50) * sin;
    var ex = mx + (cos >= 0 ? 1 : -1) * (isMobile ? 1 : 40);
    var ey = my;
    var textAnchor = cos >= 0 ? "start" : "end";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_14__/* .Sector */ .L, {
                cx: cx,
                cy: cy,
                innerRadius: innerRadius,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                fill: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__/* .black["45%"] */ .Sn["45%"]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_14__/* .Sector */ .L, {
                cx: cx,
                cy: cy,
                startAngle: startAngle,
                endAngle: endAngle,
                innerRadius: outerRadius + 6,
                outerRadius: outerRadius + 20,
                fill: "url(#".concat(payload.name, "-gradient)")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M".concat(sx, ",").concat(sy, "L").concat(mx, ",").concat(my, "L").concat(ex, ",").concat(ey),
                stroke: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__/* .primaryColors[700] */ .w2[700],
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: ex,
                cy: ey,
                r: 2,
                fill: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__/* .primaryColors[700] */ .w2[700],
                stroke: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                component: "text",
                variant: isMobile ? "label2" : "label1",
                x: ex + (cos >= 0 ? 1 : -1) * 12,
                y: ey,
                textAnchor: textAnchor,
                fill: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__/* .primaryColors[100] */ .w2[100],
                children: payload.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                component: "text",
                variant: isMobile ? "label3" : "label2",
                x: ex + (cos >= 0 ? 1 : -1) * 12,
                y: ey,
                dy: 25,
                textAnchor: textAnchor,
                fill: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__/* .primaryColors[400] */ .w2[400],
                children: "".concat((percent * 100).toFixed(2), "%")
            })
        ]
    });
};
var COLLATERALIZATION_PIE_CHART_HEIGHT = 576;
var CollateralizationGraph = function() {
    var ref = (0,_components_hooks_dashboard_useDashboardStats__WEBPACK_IMPORTED_MODULE_5__/* .useDashboardStats */ .f_)("Week"), dashboardData = ref.data, isDashboardLoading = ref.isLoading;
    var isMobile = (0,_components_hooks_utils_useIsMobile__WEBPACK_IMPORTED_MODULE_6__/* .useIsMobile */ .d)();
    var vstCollateralization = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref1;
        var todayStats = dashboardData[dashboardData.length - 1];
        var ref2;
        var todayCollateralization = (ref2 = todayStats === null || todayStats === void 0 ? void 0 : (ref = todayStats.stats) === null || ref === void 0 ? void 0 : (ref1 = ref.vstMinted) === null || ref1 === void 0 ? void 0 : ref1.collaterals) !== null && ref2 !== void 0 ? ref2 : Object.fromEntries(Object.values(_config_types__WEBPACK_IMPORTED_MODULE_12__/* .EVestaAsset */ .e2).map(function(asset) {
            return [
                asset,
                {
                    vstMinted: "0"
                }
            ];
        }));
        return Object.entries(todayCollateralization).filter(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(param, 2), _ = _param[0], vstMinted = _param[1].vstMinted;
            return vstMinted !== "0";
        }).map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(param, 2), asset = _param[0], vstMinted = _param[1].vstMinted;
            return {
                name: asset,
                value: Number(vstMinted)
            };
        });
    }, [
        JSON.stringify(dashboardData)
    ]);
    if (isDashboardLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_v2_components_ui_loadSkeleton__WEBPACK_IMPORTED_MODULE_4__/* .LoadSkeleton */ .n, {
            isLoading: isDashboardLoading,
            width: 1088,
            height: COLLATERALIZATION_PIE_CHART_HEIGHT
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
        container: true,
        sx: {
            height: isMobile ? "fit-content" : "100%",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                sm: 3,
                sx: {
                    paddingTop: 0
                },
                children: vstCollateralization.map(function(param, index) {
                    var name = param.name, value = param.value;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                            padding: "16px 24px",
                            display: "flex",
                            alignItems: "center",
                            gap: "24px",
                            marginTop: index === 0 ? undefined : "16px"
                        }, _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_8__/* .defaultBackground */ .zY),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_v2_components_ui_icons_assets__WEBPACK_IMPORTED_MODULE_2__/* .AssetIcon */ .Y, {
                                asset: name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_v2_components_ui_label__WEBPACK_IMPORTED_MODULE_3__/* .GenericInfoLabel */ .P, {
                                        labelTitle: "".concat(_config_types__WEBPACK_IMPORTED_MODULE_12__/* .ENativeAsset.VST */ .tx.VST, " Minted")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: "label2",
                                        children: (0,_components_utils_utils__WEBPACK_IMPORTED_MODULE_10__/* .displayFormatUnits */ .Hz)({
                                            value: value,
                                            displayType: _components_types__WEBPACK_IMPORTED_MODULE_9__/* .EDisplayType.USD */ .co.USD,
                                            decimal: 0
                                        })
                                    })
                                ]
                            })
                        ]
                    }, name);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                sm: 9,
                sx: {
                    height: "".concat(COLLATERALIZATION_PIE_CHART_HEIGHT, "px"),
                    flex: 1,
                    ".recharts-responsive-container .recharts-wrapper": {
                        position: "absolute !important"
                    },
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_19__/* .ResponsiveContainer */ .h, {
                    width: "99%",
                    height: "99%",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(recharts__WEBPACK_IMPORTED_MODULE_20__/* .PieChart */ .u, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                children: Object.values(_config_types__WEBPACK_IMPORTED_MODULE_12__/* .EVestaAsset */ .e2).map(function(asset) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svgGradient__WEBPACK_IMPORTED_MODULE_13__/* .SvgGradient */ .J, {
                                        id: "".concat(asset, "-gradient"),
                                        gradient: (0,_config_protocol__WEBPACK_IMPORTED_MODULE_11__/* .getAssetConfig */ .nf)(asset).styles.gradient
                                    }, asset);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_21__/* .Pie */ .b, {
                                data: vstCollateralization,
                                cx: "50%",
                                cy: "50%",
                                paddingAngle: 3,
                                dataKey: "value",
                                innerRadius: isMobile ? MOBILE_INNER_RADIUS : 160,
                                outerRadius: isMobile ? 100 : 200,
                                activeShape: renderActiveShape,
                                activeIndex: vstCollateralization.map(function(_, index) {
                                    return index;
                                }),
                                label: false,
                                children: vstCollateralization.map(function(_entry, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_22__/* .Cell */ .b, {
                                        fill: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_7__/* .black["45%"] */ .Sn["45%"]
                                    }, "cell-".concat(index));
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 41606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SvgGradient; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var SvgGradient = function(param) {
    var gradient = param.gradient, id = param.id;
    var stops = gradient.substring(gradient.indexOf("(") + 1, gradient.lastIndexOf(")")).split(",").slice(1);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("linearGradient", {
        id: id,
        children: stops.map(function(stop, index) {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(stop.split(" ").slice(1), 2), color = ref[0], offSet = ref[1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                offset: offSet,
                stopColor: color
            }, index);
        })
    });
};


/***/ }),

/***/ 28424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27842);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44206);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88433);
/* harmony import */ var _components_shared_divider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38359);
/* harmony import */ var _components_shared_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67113);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16381);







var FooterLink = function(param) {
    var href = param.href, title = param.title, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
        href: href,
        sx: {
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            children: [
                icon ? icon : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body3",
                    color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[700] */ .w2[700],
                    sx: {
                        transition: "color 0.15s linear",
                        ": hover": {
                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                        }
                    },
                    children: title
                })
            ]
        })
    });
};
var FooterLinkList = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        spacing: 3,
        textAlign: "left",
        mt: 8,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                mb: 1,
                variant: "base",
                children: title
            }),
            children
        ]
    });
};
var LandingFooter = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mb: 2,
        sx: {
            px: {
                xs: "32px",
                md: "144px"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            justifyContent: "center",
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "About",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "About Vesta",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Trust & Transparency",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Roadmap",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Learn",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Vesta Stable",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Tutorial",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Governance",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Curia Forum",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Vote on Snapshot",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Developers",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Documentation",
                                href: "https://docs.vestafinance.xyz/"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Github",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLinkList, {
                        title: "Join Us",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                            title: "Careers",
                            href: "https://vesta-finance.notion.site/Open-Roles-on-the-Core-Team-40ce0831db6642b28bdc94d3521372a9"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Community",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Twitter",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                href: "https://twitter.com/vestafinance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Medium",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                                href: "https://medium.com/@VestaFinance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Discord",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                href: "https://discord.gg/yKsr6PRtxK"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    mt: 4,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_divider__WEBPACK_IMPORTED_MODULE_2__/* .NormalDivider */ .k4, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            direction: {
                                xs: "column",
                                sm: "row"
                            },
                            mb: 4,
                            mt: 4,
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 4,
                                    justifyContent: "start",
                                    width: "100%",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "label3",
                                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[700] */ .w2[700],
                                            children: "PROUD CREATION OF MAXIMUS LABS"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
                                            sx: {
                                                textDecoration: "none"
                                            },
                                            href: "https://docs.google.com/document/d/e/2PACX-1vR35fS4nqisK3TMMmULwrZBqRu-ujqShbrZU_3KeqU51yGWe_lQtqCFAoIC1Lg5f67n4mDKYbsbZ093/pub",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sx: {
                                                    transition: "color 0.15s linear",
                                                    ": hover": {
                                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                                                    }
                                                },
                                                variant: "label3",
                                                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[900] */ .w2[900],
                                                children: "TERMS OF SERVICE"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
                                            href: "https://docs.google.com/document/d/e/2PACX-1vRAewaErhuxxT6Hxss_3IWNVw3-PlByipiDIXYwNhfVF0EDEp0CGbBPSjSzN9JHbmafM5BtU0KOf0w0/pub",
                                            sx: {
                                                textDecoration: "none"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sx: {
                                                    transition: "color 0.15s linear",
                                                    ": hover": {
                                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                                                    }
                                                },
                                                variant: "label3",
                                                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[900] */ .w2[900],
                                                children: "PRIVACY POLICY"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    variant: "h6",
                                    sx: {
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .white["15%"] */ .ix["15%"],
                                        display: "flex",
                                        gap: "1em",
                                        justifyContent: "space-around",
                                        textAlign: "center",
                                        mt: {
                                            xs: 4,
                                            sm: 0
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "V"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "E"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "S"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "T"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "A"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingFooter);


/***/ }),

/***/ 47697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99226);




var SlideWrapper = function(param) {
    var children = param.children, sx = param.sx, onMouseMove = param.onMouseMove;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onMouseMove: onMouseMove,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            backgroundSize: "cover",
            px: {
                xs: "32px",
                md: "144px"
            },
            height: "100%",
            mb: 40
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SlideWrapper);


/***/ }),

/***/ 41394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FadeContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99226);

var FadeContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var visible = param.visible, time = param.time;
    return {
        opacity: visible ? 1 : 0,
        transition: "opacity ".concat(time, "s ease")
    };
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8844,3604,8687,9774,2888,179], function() { return __webpack_exec__(27003); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);